import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f61916e0")
const _hoisted_1 = { ref: "header" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "grid navigation"
}
const _hoisted_4 = {
  key: 2,
  class: "grid language-switch"
}
const _hoisted_5 = { class: "grid account-and-store-buttons-wrapper" }
const _hoisted_6 = { class: "grid account-button" }
const _hoisted_7 = { class: "grid store-btn" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMetaInfo = _resolveComponent("HeaderMetaInfo")!
  const _component_HeaderMenuMobile = _resolveComponent("HeaderMenuMobile")!
  const _component_MenuBtn = _resolveComponent("MenuBtn")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_TheHeaderMenu = _resolveComponent("TheHeaderMenu")!
  const _component_LanguageSwitch = _resolveComponent("LanguageSwitch")!
  const _component_AccountButton = _resolveComponent("AccountButton")!
  const _component_CartBtn = _resolveComponent("CartBtn")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_HeaderMetaInfo),
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock(_component_HeaderMenuMobile, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_MenuBtn, {
            key: 0,
            class: _normalizeClass(["grid", { 'menu-btn--active': _ctx.isMobileMenuOpen }]),
            "is-active": _ctx.isMobileMenuOpen,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMobileMenuOpen = !_ctx.isMobileMenuOpen))
          }, null, 8, ["class", "is-active"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Logo),
      (_ctx.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_TheHeaderMenu)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_LanguageSwitch)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_AccountButton)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_CartBtn)
        ])
      ])
    ])
  ], 512))
}